/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeDimensions_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user" | "SbSharedRefineMenuDimensionUnitRadioSelect_user">;
    readonly " $refType": "SbSharedRefineMenuInputRangeDimensions_user";
};
export type SbSharedRefineMenuInputRangeDimensions_user$data = SbSharedRefineMenuInputRangeDimensions_user;
export type SbSharedRefineMenuInputRangeDimensions_user$key = {
    readonly " $data"?: SbSharedRefineMenuInputRangeDimensions_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeDimensions_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "measurementUnit",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
      "args": null
    }
  ]
};
(node as any).hash = 'bc160ffbcef332cfaf1a6abe33b29191';
export default node;
